import React from 'react';
import './StatsGrid.css';

export interface StatItem {
  id: string;
  value: string | number;
  label: string;
  icon?: string;
  color?: 'primary' | 'success' | 'warning' | 'error' | 'info' | 'muted';
  variant?: 'default' | 'compact' | 'large';
}

export interface StatsGridProps {
  items: StatItem[];
  className?: string;
  variant?: 'default' | 'compact' | 'large';
  columns?: 'auto' | 2 | 3 | 4;
}

const StatsGrid: React.FC<StatsGridProps> = ({ 
  items, 
  className = '', 
  variant = 'default',
  columns = 'auto'
}) => {
  // Универсальный алгоритм: по 2 карточки в ряд, последняя строка — 1 или 2 в зависимости от остатка
  const getCardLayout = (itemCount: number) => {
    const layoutNames = ['single', 'double', 'triple', 'quadruple', 'quintuple', 'sextuple', 'septuple', 'octuple'] as const;
    const layout: (typeof layoutNames)[number] | 'grid' = itemCount >= 1 && itemCount <= 8 ? layoutNames[itemCount - 1] : 'grid';

    const rows: { items: number[]; fullWidth: boolean }[] = [];
    let i = 0;

    while (i < itemCount) {
      if (i + 2 <= itemCount) {
        rows.push({ items: [i, i + 1], fullWidth: false });
        i += 2;
      } else {
        rows.push({ items: [i], fullWidth: true });
        i += 1;
      }
    }

    return { layout, rows };
  };

  const layout = getCardLayout(items.length);
  const gridClass = `stats-grid stats-grid--${layout.layout} stats-grid--${variant}`;

  return (
    <div className={`${gridClass} ${className}`}>
      {layout.rows.map((row, rowIndex) => (
        <div key={rowIndex} className="stats-row">
          {row.items.map((itemIndex) => {
            const item = items[itemIndex];
            return (
              <div 
                key={item.id} 
                className={`stat-item stat-item--${item.variant || variant} stat-item--${item.color || 'muted'} ${row.fullWidth ? 'stat-item--full-width' : ''}`}
              >
                {item.icon && (
                  <div className="stat-icon">
                    <i className={item.icon}></i>
                  </div>
                )}
                <div className="stat-content">
                  <div className="stat-value">{item.value}</div>
        <div className="stat-label">{item.label}</div>
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default StatsGrid;
